// Firebase configuration for OBC Cloud Web
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDGXVWg7YDdEIhier5V9CbbC9hrXRSUAaw",
  authDomain: "obc-cloud.firebaseapp.com",
  projectId: "obc-cloud",
  storageBucket: "obc-cloud.firebasestorage.app",
  messagingSenderId: "570350159026",
  appId: "1:570350159026:web:6d712a658eebc7f16c35ab",
  measurementId: "G-KF2DJW6Q2D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider('apple.com');

// Configure Apple provider
appleProvider.addScope('email');
appleProvider.addScope('name');

// Google Sign-In
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential?.accessToken;
    const idToken = await result.user.getIdToken();
    
    return {
      success: true,
      user: result.user,
      accessToken: token,
      idToken: idToken,
      email: result.user.email,
      name: result.user.displayName,
    };
  } catch (error) {
    console.error('Google Sign-In Error:', error);
    return {
      success: false,
      error: error.message,
      code: error.code,
    };
  }
};

// Apple Sign-In
export const signInWithApple = async () => {
  try {
    const result = await signInWithPopup(auth, appleProvider);
    const credential = OAuthProvider.credentialFromResult(result);
    
    // Get Firebase ID token (not Apple's token)
    const firebaseIdToken = await result.user.getIdToken();
    
    // Apple credential tokens (may be null)
    const appleIdToken = credential?.idToken;
    const accessToken = credential?.accessToken;
    
    // Get Apple user ID from provider data
    const appleProviderData = result.user.providerData.find(p => p.providerId === 'apple.com');
    
    console.log('Apple Sign-In result:', {
      email: result.user.email,
      displayName: result.user.displayName,
      appleUid: appleProviderData?.uid,
      hasFirebaseToken: !!firebaseIdToken,
      hasAppleToken: !!appleIdToken,
    });
    
    return {
      success: true,
      user: result.user,
      firebaseIdToken: firebaseIdToken,
      idToken: appleIdToken,
      accessToken: accessToken,
      email: result.user.email,
      name: result.user.displayName,
      appleUserId: appleProviderData?.uid || result.user.uid,
    };
  } catch (error) {
    console.error('Apple Sign-In Error:', error);
    return {
      success: false,
      error: error.message,
      code: error.code,
    };
  }
};

// Sign out
export const firebaseSignOut = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export { auth, googleProvider, appleProvider };
export default app;
